import { Button, Form, Input, message, Popconfirm } from "antd";
import { useEffect, useState } from "react";
import { PiPlus } from "react-icons/pi";
import { editCategoryTitle, getCategoryByID } from "../action";
import { useParams } from "react-router-dom";
import { MdEdit } from "react-icons/md";

type Props = {
  onCategoryEdited?: () => void;
};

interface FormData {
  title: string;
}
const EditCategory = (props: Props) => {
  const { id } = useParams();
  const { onCategoryEdited } = props;
  const [form] = Form.useForm<FormData>();
  const [loading, setIsLoading] = useState<boolean>(false);

  const fetchData = async () => {
    if (id) {
      const category = await getCategoryByID(id);
      if (category) {
        form.setFieldsValue({
          title: category.MainInfo.Title,
        });
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, [id]);
  const handleSubmit = async (values: FormData) => {
    setIsLoading(true);
    try {
      const result = await editCategoryTitle(id!, values.title);
      if (result) {
        message.success("Category edited successfully!");
        if (onCategoryEdited) {
          onCategoryEdited();
        }
      } else {
        message.error("Failed to edit category. Please try again.");
      }
    } catch (err) {
      message.error("Failed to edit category. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Form form={form} onFinish={handleSubmit}>
      <Form.Item name="title">
        <Input placeholder="Category title ..." />
      </Form.Item>
      <Popconfirm
        title="Edit Category"
        description="Are you sure you want to edit this category?"
        onConfirm={() => form.submit()}
        okText="Yes"
        cancelText="No"
      >
        <Button type="primary" icon={<MdEdit />} loading={loading}>
          Edit Title
        </Button>
      </Popconfirm>
    </Form>
  );
};

export default EditCategory;
